import { BaseCrudService } from "@/services/base";
import { Customer } from "@/swagger/models";

class CustomerService extends BaseCrudService<Customer> {
    constructor() {
        super({
            apiPrefix: "customers",
            entityName: "customer",
        });
    }

    build(fields?: Partial<Customer>): Customer {
        return Object.assign(
            {
                name: "New customer",
                address: "",
                postalCode: "",
                city: "",
                province: "",
                country: "",
                oktaGroupId: "",
            },
            fields,
        );
    }
}

export const customerService = new CustomerService();
